export enum ProcessStep {
  Upload,
  Download,
}
